"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _systemConfig = _interopRequireWildcard(require("@/api/systemConfig.js"));
var systemConfigApi = _systemConfig;
var _user = require("@/api/user");
var _marketing = require("@/api/marketing");
var _index = _interopRequireDefault(require("@/views/appSetting/wxAccount/wxTemplate/index.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "UserDetails",
  components: {
    Template: _index.default
  },
  props: {
    uid: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      loading: false,
      columns: [],
      Visible: false,
      list: [{
        val: '0',
        label: '消费记录'
      }],
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 6,
        type: '0',
        userId: ''
      },
      psInfo: null,
      customConfig: null
    };
  },
  mounted: function mounted() {
    var _this = this;
    if (this.uid) {
      this.getHeader();
      this.getInfo();
    }
    systemConfigApi.configInfo({
      id: "147"
    }).then(function (data) {
      _this.customConfig = data;
      console.log('个性配置');
      console.log(_this.customConfig);
      // { val: '1', label: '积分明细' },
      // { val: '2', label: '签到记录' },
      //{ val: '3', label: '持有优惠券' },
      // { val: '4', label: '余额变动' },
      // { val: '5', label: '好友关系' }
      if (_this.customConfig.enablePoints == 1) {
        _this.list.push({
          val: '1',
          label: '积分明细'
        });
      }
      if (_this.customConfig.enableRecharge == 1) {
        _this.list.push({
          val: '4',
          label: '余额变动'
        });
      }
      if (_this.customConfig.enableCoupon == 1) {
        _this.list.push({
          val: '3',
          label: '持有优惠券'
        });
      }
    });
  },
  methods: {
    translate: function translate(bizType) {
      return this.$constants.bizType.find(function (item) {
        return item.value == bizType;
      }).label;
    },
    changeType: function changeType(key) {
      this.tableFrom.type = key;
      if (key === '1') {
        this.integral();
      } else {
        this.getInfo();
      }
    },
    integral: function integral() {
      var _this2 = this;
      this.loading = true;
      (0, _marketing.integralListApi)({
        limit: this.tableFrom.limit,
        page: this.tableFrom.page
      }, {
        uid: this.uid
      }).then(function (res) {
        _this2.tableData.data = res.recordList;
        _this2.tableData.total = res.recordCount;
        _this2.columns = [{
          title: '来源/用途',
          key: 'title',
          minWidth: 120
        }, {
          title: '增加/扣减',
          key: 'type',
          minWidth: 120
        }, {
          title: '积分变化',
          key: 'integral',
          minWidth: 120
        }, {
          title: '变化后积分',
          key: 'balance',
          minWidth: 120
        }, {
          title: '日期',
          key: 'updateTime',
          minWidth: 120
        }, {
          title: '备注',
          key: 'mark',
          minWidth: 120
        }];
        _this2.loading = false;
      }).catch(function (res) {
        _this2.loading = false;
      });
    },
    getInfo: function getInfo() {
      var _this3 = this;
      this.tableFrom.userId = this.uid;
      this.loading = true;
      (0, _user.infobyconditionApi)(this.tableFrom).then(function (res) {
        _this3.tableData.data = res.recordList;
        _this3.tableData.total = res.recordCount;
        switch (_this3.tableFrom.type) {
          case '0':
            _this3.columns = [{
              title: '订单类型',
              key: 'bizType',
              minWidth: 150
            }, {
              title: '订单ID',
              key: 'orderId',
              minWidth: 250
            }, {
              title: '收货人',
              key: 'realName',
              minWidth: 90
            }, {
              title: '商品数量',
              key: 'totalNum',
              minWidth: 80
            }, {
              title: '商品总价',
              key: 'totalPrice',
              minWidth: 150
            }, {
              title: '实付金额',
              key: 'payPrice',
              minWidth: 90
            }, {
              title: '交易完成时间',
              key: 'payTime',
              minWidth: 160
            }];
            break;
          case '2':
            _this3.columns = [{
              title: '动作',
              key: 'title',
              minWidth: 120
            }, {
              title: '获得积分',
              key: 'number',
              minWidth: 120
            }, {
              title: '签到时间',
              key: 'createTime',
              minWidth: 120
            }, {
              title: '备注',
              key: 'title',
              minWidth: 120
            }];
            break;
          case '3':
            _this3.columns = [{
              title: '优惠券名称',
              key: 'name',
              minWidth: 120
            }, {
              title: '面值',
              key: 'money',
              minWidth: 120
            }, {
              title: '有效期',
              key: 'endTime',
              minWidth: 120
            }, {
              title: '最低消费额',
              key: 'minPrice',
              minWidth: 120
            }, {
              title: '兑换时间',
              key: 'updateTime',
              minWidth: 120
            }];
            break;
          case '4':
            _this3.columns = [{
              title: '变动金额',
              key: 'number',
              minWidth: 120
            }, {
              title: '变动后',
              key: 'balance',
              minWidth: 120
            }, {
              title: '类型',
              key: 'title',
              minWidth: 120
            }, {
              title: '创建时间',
              key: 'add_time',
              minWidth: 120
            }, {
              title: '备注',
              key: 'mark',
              minWidth: 120
            }];
            break;
          default:
            _this3.columns = [{
              title: 'ID',
              key: 'uid',
              minWidth: 120
            }, {
              title: '昵称',
              key: 'nickname',
              minWidth: 120
            }, {
              title: '等级',
              key: 'level',
              minWidth: 120
            }, {
              title: '加入时间',
              key: 'createTime',
              minWidth: 120
            }];
        }
        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      if (this.tableFrom.type === '1') {
        this.integral();
      } else {
        this.getInfo();
      }
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      if (this.tableFrom.type === '1') {
        this.integral();
      } else {
        this.getInfo();
      }
    },
    getHeader: function getHeader() {
      var _this4 = this;
      (0, _user.topdetailApi)({
        userId: this.uid
      }).then(function (res) {
        _this4.psInfo = res;
      });
    }
  }
};